import React from 'react';
import * as styles from './index.module.scss';

import RichText from '../../lib/contentful/rich-text';

const RichContentContainer = ({ block }) => {
    
    return(
        <div
            className={`${styles.content} content`}
            style={{textAlign:block.horizontalAlignment}}
        >{RichText(block?.content)}</div>
    )
}

export default RichContentContainer;